import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke083aRequest, Sgke083aResponse, Sgke083aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke083aService {

  /**
   * コンストラクタ
   * @param {Sgke083aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke083aService
   */
  constructor(public service: Sgke083aService, public apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * Sgke083aAPI実行
   *
   * @param {Sgke083aRequest} request
   * @return {*}  {Observable<Sgke083aResponse>}
   * @memberof UsedSgke083aService
   */
  public doSgke083a(request: Sgke083aRequest): Observable<Sgke083aResponse> {

    return this.service.sgke083aPost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE083A');
          return throwError(err.message);
        })
      );
  }

}

